import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-data-privacy-policy',
  templateUrl: './data-privacy-policy.component.html',
  styleUrls: ['./data-privacy-policy.component.scss'],
})
export class DataPrivacyPolicyComponent implements OnInit {
  checked = false;
  message = '';
  constructor(
    private http: HttpClient,
    private dialogRef: MatDialogRef<DataPrivacyPolicyComponent>
  ) {}

  ngOnInit(): void {
    this.http
      .get('/admin/data-privacy-template-details')
      .subscribe((res: any) => {
        const response: any = res?.data;
        this.message = response?.docTmplt;
      });
  }
  accept() {
    this.http.get('/admin/data-privacy').subscribe((res) => {
      this.dialogRef.close(true);
    });
  }
}
